import { LandingProductCurrencyEnum } from "@dev/ee-api/ee-api-models";
import { MIN_PRICE_CURRENCY_PLN, MIN_PRICE_GENERAL } from "../constants";

export const getProductMinPrice = (currency: LandingProductCurrencyEnum): number => {
    switch (currency) {
        case LandingProductCurrencyEnum.PLN:
            return MIN_PRICE_CURRENCY_PLN;
        default:
            return MIN_PRICE_GENERAL
    }
}
